<template>
    <section class="layout">
        <div>
            <Form ref="formValidate" :model="formValidate" :label-width="150">
                <FormItem label="公告类型" prop="type" :rules="{required: true, message: '请选择公告类型', trigger: 'change'}">
                    <Select v-model="formValidate.type">
                        <Option v-for="(item, key) in NOTICE_TYPE_list" :value="item.value" :key="key" :label="item.label"></Option>
                    </Select>
                </FormItem>
                <FormItem v-if="formValidate.type === '菜单弹窗'" label="弹窗挂载一级菜单名称" prop="menu" :rules="{required: true, message: '请选择一级菜单名称', trigger: 'change'}">
                    <Select v-model="formValidate.menu">
                        <Option v-for="(item, key) in menuList" :value="item.fdFrontLink" :key="key" :label="item.fdName"></Option>
                    </Select>
                </FormItem>
                <FormItem label="公告标题" prop="title" :rules="{required: true, message: '公告标题不能为空', trigger: 'blur'}">
                    <Input v-model="formValidate.title"></Input>
                </FormItem>
                <FormItem label="正文" prop="text">
                    <div id="editor"></div>
                </FormItem>
                <FormItem label="公告附件" prop="appendix">
                    <Upload ref="upload"
                            :format="['xls','xlsx','doc','docx','jpeg','jpg','png','gif','pdf','txt','xml','rar','zip', '7z', 'pptx']"
                            action="/gscint/supplierfile/uploadFile"
                            :default-file-list="defaultFileList">
                        <Button type="ghost" icon="ios-cloud-upload-outline" :loading="loading">上传附件</Button>
                    </Upload>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem label="发布公告" prop="status">
                            <m-switch v-model="formValidate.status" true-value="0" false-value="1"></m-switch>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="formValidate.type !== '弹窗公告'">
                        <FormItem label="公告置顶" prop="isTop">
                            <m-switch v-model="formValidate.isTop" true-value="0" false-value="1"></m-switch>
                        </FormItem>
                    </Col>
                </Row>
                <Row style="margin: auto; text-align: center;padding-left:150px">
                    <m-button type="primary" :loading="loading" @click="handleSave">保存</m-button>
                    <Button type="default" style="margin-left:20px;" @click="back">返回</Button>
                </Row>
            </Form>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import E from 'wangeditor';

export default {
    props: {
        /* 是否只读 */
        readonly: {
            type: Boolean,
            default: () => false,
        },
        isNew: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            formValidate: {
                type: '',
                title: '',
                isTop: '1',
                status: '1',
            },
            defaultFileList: [],
            NOTICE_TYPE_list: [
                {
                    label: '海外弹窗公告',
                    value: '海外弹窗公告',
                },
            ],
            loading: false,
            id: '',
        };
    },
    methods: {
        subPath(path) {
            const test1 = path.lastIndexOf('/');
            const test2 = path.lastIndexOf('\\');
            const test = Math.max(test1, test2);
            return test < 0 ? path : path.substring(test + 1);
        },
        handleSave() {
            const { isNew } = this;
            const names = [];
            const ids = [];
            let params = {};
            const self = this;
            if (this.$refs.upload.fileList.length > 0) {
                this.$refs.upload.fileList.forEach(el => {
                    ids.push(el.response.data.docId);
                    names.push(this.subPath(el.response.data.fileName));
                });
                params = {
                    appendix: ids.join(','),
                    appendixName: names.join(','),
                    id: this.id,
                };
            }
            this.$refs.formValidate.validate(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post(`/gscint/advertise/${isNew ? 'add' : 'update'}`,
                        {
                            title: this.formValidate.title,
                            isTop: this.formValidate.isTop,
                            status: this.formValidate.status,
                            type: this.formValidate.type,
                            content: this.editor.txt.html(),
                            ...params,
                        })
                        .then(() => {
                            this.$Notice.success({
                                title: !isNew ? '保存成功' : '发布成功',
                                desc: !isNew ? '公告保存成功' : '公告发布成功！ ',
                                duration: 2,
                                onClose: () => {
                                    this.closeTab();
                                },
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        getDetail(id) {
            axios.get('/gscint/advertise/selectKey', {
                params: {
                    id,
                },
            })
                .then((res) => {
                    const { data, success } = res.data;
                    if (success) {
                        Object.assign(this.formValidate, data);
                        this.editor.txt.text(data.content);
                        if (data.appendixName) {
                            const names = data.appendixName.split(',');
                            const ids = data.appendix.split(',');
                            names.forEach((name, index) => {
                                const docId = ids[index];
                                this.defaultFileList.push({
                                    name,
                                    docId,
                                    url: `${window.location.host}/gscint/supplierfile/downloadFile?docId=${ids[index]}`,
                                    response: {
                                        data: {
                                            docId,
                                            fileName: name,
                                        },
                                    },
                                });
                            });
                        }
                    }
                });
        },
        closeTab() {
            this.$closeTab({
                name: this.isNew ? 'announcementAdd' : 'announcementEdit',
            });
        },
        back() {
            this.closeTab();
            this.$router.push({
                name: 'announcementList',
            });
        },
        init() {
            if (!this.isNew) {
                const { id } = this.$route.query;
                this.id = id;
                this.getDetail(id);
            }
        },
    },
    mounted() {
        this.editor = new E('#editor');
        this.editor.create();
    },
    activated() {
        this.init();
    },
};
</script>
<style scoped lang="less">
.layout {
    margin: 10px;
    padding: 10px;
    background: #FFF;
}
</style>
